// extracted by mini-css-extract-plugin
export default {"gallerySection":"Gallery_gallerySection__Cm4sk"};